const origin = {
  production: window.location.origin.replace(/(console\.|admin\.)/g, ""),
  development: "http://dna-h.ir",
};
const socketOrigin = {
  production: window.location.origin.replace(/(console\.|admin\.)/g, "node."),
  development: "http://node.dna-h.ir",
};

export const hostname = origin[process.env.NODE_ENV];
export const socketHostname = socketOrigin[process.env.NODE_ENV];

export const base_url = `${hostname}`;
